module.exports = __webpack_public_path__ + "img/ceyiceTwo copy.b509fc34.png";